import React, { useState } from "react"
import { useEffect } from "react"
import { Button } from "@mui/material"
import { List, ListItem } from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import IconButton from "@mui/material/IconButton"
import { CAlert } from "@coreui/react"

import "./DayComponent.css"

import { useUserAuth } from "../../../firebase/UserAuthContext"
import { useNavigate } from "react-router-dom"

import { db } from "../../../firebase/firebase_config"
import {
	arrayRemove,
	arrayUnion,
	doc,
	updateDoc,
	Timestamp,
	setDoc,
} from "firebase/firestore"

const DayComponent = ({ data }) => {
	const { user } = useUserAuth()
	const navigate = useNavigate()
	const [alertVisible, setAlertVisible] = useState(false)
	const [alertMessage, setAlertMessage] = useState("")

	function refreshPage() {
		window.location.reload()
	}

	const registrarButtonClick_Handler = () => {
		navigate("/signin")
	}
	const apuntarButtonClick_Handler = async () => {
		const filtered_list_length = data.PARTICIPANTES?.filter(
			(e) => e === user.displayName
		).length
		if (filtered_list_length > 0) {
			//alert("Ya estas registrado. No puedes registrarte más veces!")
			setAlertMessage("Ya estas registrado. No puedes registrarte más veces!")
			setAlertVisible(true)
			return
		}
		try {
			const dayRef = doc(db, "Schedule", `${data.DIA}`)
			await updateDoc(dayRef, {
				PARTICIPANTES: arrayUnion(user.displayName),
			})
			refreshPage()
		} catch (error) {
			console.log(
				"Error updating participants list to firestore data: ",
				error.message
			)
		}
	}

	const deleteButtonClick_Handler = async () => {
		//console.log("delete")
		try {
			const dayRef = doc(db, "Schedule", `${data.DIA}`)
			await updateDoc(dayRef, {
				PARTICIPANTES: arrayRemove(user.displayName),
			})
			refreshPage()
			alert("Eliminado de la lista correctamente!")
		} catch (error) {
			console.log(
				"Error deleting from participants list on firestore data: ",
				error.message
			)
		}
	}

	const change_dataClearedFlag = async (value) => {
		try {
			const dayRef = doc(db, "Schedule", `${data.DIA}`)
			await updateDoc(dayRef, {
				dataCleared: value,
			})
		} catch (error) {
			console.log(
				"Error resetting dataCLeared flag on firestore data: ",
				error.message
			)
		}
	}

	useEffect(() => {
		if (data.ENABLED) {
			var current_date = new Date()
			// Sunday - Saturday : 0 - 6
			const day = current_date.getDay()

			var dataCleared = data?.dataCleared

			if (day === 0) {
				//On Sundays
				if (!dataCleared) {
					registerParticipants()
					console.log(data.DIA + " - Data reset")
				} else {
					console.log(data.DIA + " - NOT Data reset")
				}
			}
			if (day === 1) {
				//On mondays
				//Reset dataCleared flag
				change_dataClearedFlag(false)
			}
			console.log(data.DIA + "- Flag:" + dataCleared)
		}
	}, [data.dataCleared])

	const registerParticipants = async () => {
		try {
			const dayRef = doc(db, "Schedule", `${data.DIA}`)

			//Save current list
			var fields = data.date.split("/")
			var d = new Date(fields[2] + "-" + fields[1] + "-" + fields[0])
			console.log(d)
			const reg_date = Timestamp.fromDate(d)
			const regRef = doc(db, "Register", d.toDateString())
			const reg_array = []
			if (data.PARTICIPANTES) {
				data.PARTICIPANTES.map((x) => reg_array.push(x))
			}
			const register_data = {
				date: reg_date,
				participants: reg_array,
			}
			await setDoc(regRef, register_data, { merge: true })
			//Reset list
			await updateDoc(dayRef, {
				PARTICIPANTES: [],
			})

			change_dataClearedFlag(true)
		} catch (error) {
			console.log(
				"Error resetting participants list on firestore data: ",
				error
			)
		}
	}

	let participantListComponent = <div>VACIO</div>
	participantListComponent = (
		<List className="participants-list">
			{data.PARTICIPANTES.map((participant, i) => (
				<ListItem
					key={"item" + i}
					secondaryAction={
						user?.displayName === participant ? (
							<IconButton
								aria-label="comment"
								onClick={deleteButtonClick_Handler}
							>
								<DeleteIcon />
							</IconButton>
						) : (
							<></>
						)
					}
				>
					{participant}
				</ListItem>
			))}
		</List>
	)
	return (
		<>
			<div
				className="day-component-day-container"
				style={{
					backgroundColor: data.bgColor,
					color: data.txtColor,
				}}
			>
				<CAlert
					color="danger"
					dismissible
					visible={alertVisible}
					onClose={() => setAlertVisible(false)}
				>
					{alertMessage}
				</CAlert>
				<span className="day-component-cardTitle">{data.DIA}</span>
				<span className="day-component-cardSubTitle">{data.date}</span>
				<span className="day-component-cardHour">{data.HORA}</span>
				<span className="day-component-cardText">
					<span className="hordayario-component-cardText-bold">Detalles</span>
					<br className=""></br>
					<br className=""></br>
				</span>
				<span className="day-component-cardText">
					{data.CALENTAMIENTO}min calentamiento
				</span>
				<span className="day-component-cardText">
					{data.PISCINA}h piscina completa
				</span>

				<br className=""></br>
				<br className=""></br>
				{!data.ENABLED ? (
					<Button variant="contained" disabled>
						NO DISPONIBLE
					</Button>
				) : (
					<Button
						variant="contained"
						onClick={
							user ? apuntarButtonClick_Handler : registrarButtonClick_Handler
						}
					>
						{user ? "Apuntar" : "Registrar"}
					</Button>
				)}
				<br className=""></br>

				{user && (
					<>
						<span>
							Apuntados: {data.PARTICIPANTES ? data.PARTICIPANTES.length : 0}
						</span>
						<br className=""></br>
						{participantListComponent}
					</>
				)}
			</div>
		</>
	)
}

export default DayComponent
